// Shared identifiers + types for the theme system. Lives in src/themes/ so
// non-React code (themePrefs, tests) can reach them without importing
// ThemeContext.tsx (which pulls in the MUI tree).

export const THEME_IDS = ['reef', 'studio', 'smartai', 'constellations'] as const;
export type ThemeId = (typeof THEME_IDS)[number];

export type ColorMode = 'dark' | 'light';
